var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-single-product ctm-single-product--preview" },
    [
      _c("div", { staticClass: "ctm-single-product__card" }, [
        _c(
          "div",
          { staticClass: "ctm-single-product__body" },
          [
            _c("p", { staticClass: "ctm-single-product__name" }, [
              _vm._v(_vm._s(_vm.field.label || "Product"))
            ]),
            _vm._v(" "),
            _vm.field.price && _vm.field.price.is_flexible
              ? [
                  _c("span", { staticClass: "ctm-single-product__price-lbl" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.isDonation ? "Amount" : "Price") +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ctm-single-product__price-wrap" }, [
                    _c("span", { staticClass: "ctm-single-product__symbol" }, [
                      _vm._v("$")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "ctm-single-product__price-input",
                      attrs: { type: "number", disabled: "" },
                      domProps: { value: _vm.field.price.min || 0 }
                    })
                  ])
                ]
              : [
                  _c(
                    "span",
                    { staticClass: "ctm-single-product__price-badge" },
                    [
                      _vm._v(
                        "\n          $" + _vm._s(_vm.fixedPrice) + "\n        "
                      )
                    ]
                  )
                ]
          ],
          2
        ),
        _vm._v(" "),
        _vm.field.quantity && _vm.field.quantity.status
          ? _c("div", { staticClass: "ctm-single-product__qty-wrap" }, [
              _c("span", { staticClass: "ctm-single-product__qty-lbl" }, [
                _vm._v("Qty")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctm-qty-stepper" }, [
                _c(
                  "button",
                  {
                    staticClass: "ctm-qty-btn ctm-qty-btn--minus",
                    attrs: { type: "button", disabled: "" }
                  },
                  [_vm._v("−")]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "ctm-qty-input",
                  attrs: { type: "number", disabled: "" },
                  domProps: { value: _vm.field.quantity.min || 1 }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ctm-qty-btn ctm-qty-btn--plus",
                    attrs: { type: "button", disabled: "" }
                  },
                  [_vm._v("+")]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.field.help
        ? _c("span", { staticClass: "contactum-help" }, [
            _vm._v(_vm._s(_vm.field.help))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }